<template>
    <b-modal :visible="Visible" centered no-close-on-backdrop no-close-on-esc modal-class="shareModal" v-if="$store.getters['CheckAction']('Read', undefined, Action)">
        <template #modal-header>
            <h6>{{ $t('SharingElements') }}</h6>
            <b-icon role="button" icon="x-lg" font-scale="1.5" @click="$emit('CancelEvent');" v-b-tooltip.hover :title="$t('Close')" /><!-- Fermer -->
        </template>

        <b-row>
            <b-col class="text-center pb-2">
            	<h6>{{ $t('ElementTypeShare') }}</h6> <!--  Quel type d'éléments voulez-vous partager ? -->
            </b-col>
        </b-row>

        <!-- Liste des types d'élements -->
        <b-list-group flush>
            <b-list-group-item v-for="item in shareChoiceList" :key="item.ShareType" button @click="shareType = item.ShareType; title = item.Label; $emit('ShareTypeEndedEvent');" class="d-flex justify-content-between align-items-center px-1">
                {{ item.Label }}
                <b-badge v-if="item.ShareCount > 0" pill class="p-2">
                    <!-- <b-icon icon="hourglass-split"/> -->
                    {{item.ShareCount}}
                </b-badge>
            </b-list-group-item>
        </b-list-group>

        <template #modal-footer="{ cancel }">
            <b-button :variant="'outline-'+Variant" pill @click="$emit('CancelEvent');">{{ $t('Close') }}</b-button><!-- Fermer -->
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { Component, InjectReactive, Prop, PropSync, Vue } from 'vue-property-decorator';
    import ShareComponent from './ShareComponent.vue';
    import ShareChoiceItem from '@/types/ShareChoiceItem';
    import ShareItem from '@/types/ShareItem';
    import locales from './locales/ShareChoice.json';

    /** Composant permettant la sélection des différents composants à partager (filtres, masques, tableau de bord, ...) */
    @Component({
        components: {
            ShareComponent
        },
        i18n: { messages : locales }
    })
    export default class ShareChoice extends Vue{
        /** Indication pour afficher ou non la modale */
        @Prop()
        public Visible!: boolean;

        @Prop()
        public Variant!: string;

        @PropSync("ShareType")
        public shareType!: string;

        /** Nom du type d'élements à partager */
        @PropSync('Title')
        private title!: string;

        /** Droit disponible pour l'utilisateur en cours */
        @InjectReactive()
        public Action!: string;

        /** Liste des type d'éléments partageables */
        private shareComponentList : ShareItem[] = [];

        /** Liste d'affichage des types d'éléments partageables */
        private shareChoiceList: ShareChoiceItem[] = [] ;

        private getShareChoices(){

            this.shareChoiceList.push({ShareType : "Dashboard", Label: this.$t('Dashboard').toString(), ShareCount : this.shareComponentList.filter(u => u.ShareType == "Dashboard" && u.Share).length });
            this.shareChoiceList.push({ShareType : "Perimeter", Label: this.$t('Perimeter').toString(), ShareCount : this.shareComponentList.filter(u => u.ShareType == "Perimeter" && u.Share).length });
            this.shareChoiceList.push({ShareType : "Mask", Label: this.$t('Mask').toString(), ShareCount : this.shareComponentList.filter(u => u.ShareType == "Mask" && u.Share).length });
        }

        mounted(){
            this.shareComponentList = this.$store.getters["GetSharableItems"];

            this.getShareChoices();

            console.debug("ShareChoice - mounted - shareComponentList", this.shareComponentList);
        }
    }
</script>

<style scoped>
</style>